import React, { useState, Fragment, memo, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { Grid, Tooltip } from '@material-ui/core';
import { Label } from 'reactstrap';
import PropTypes from 'prop-types';
import { ptBR } from 'date-fns/locale';
import { format } from 'date-fns';
import { v1 as uuid } from 'uuid';
import { PRESENCE_TYPE } from '../utils/constants';
import { getRoundPercentageWithSymbol } from '../utils/smartutils';

const PresenceGridMaintenance = (props) => {
  const { t, attendanceWrapper, change, header } = props;

  const [data, setData] = useState({});
  useEffect(() => {
    setData(attendanceWrapper);
  }, [attendanceWrapper]);

  useEffect(() => {
    change('attendanceWrapper', data);
  }, [data]);

  const getFrequencyByPresence = (totalPresence, workdays) => {
    return totalPresence > 0 && workdays > 0
      ? (totalPresence / workdays) * 100
      : 0;
  };

  const getTotalPresenceByStudentId = (arrayData, studentId) => {
    let presences = 0;
    arrayData.forEach((item) => {
      item.closingAttendanceStudent.forEach((student) => {
        if (student.studentId === studentId) {
          student.classes.forEach((classe) => {
            if (
              classe.attendance === PRESENCE_TYPE.PRESENT ||
              classe.attendance === PRESENCE_TYPE.JUSTIFIED
            ) {
              presences += 1;
            }
          });
        }
      });
    });
    return presences;
  };

  const changePresence = (
    classe,
    indexClasse,
    student,
    indexStudent,
    dataGrid,
    indexGrid
  ) => {
    let newTypePresence;
    switch (classe.attendance) {
      case PRESENCE_TYPE.PRESENT:
        newTypePresence = PRESENCE_TYPE.LACK;
        break;
      case PRESENCE_TYPE.LACK:
        newTypePresence = PRESENCE_TYPE.JUSTIFIED;
        break;
      case PRESENCE_TYPE.JUSTIFIED:
        newTypePresence = PRESENCE_TYPE.PRESENT;
        break;
      default:
        newTypePresence = PRESENCE_TYPE.PRESENT;
        break;
    }
    const dataColumnUpdated = { ...dataGrid };
    const updatedData = { ...data };
    const updatedStudent = { ...student };
    updatedStudent.classes[indexClasse] = {
      ...classe,
      attendance: newTypePresence,
    };
    dataColumnUpdated.closingAttendanceStudent[indexStudent] = updatedStudent;
    updatedData.listCycleClosingAttendanceDate[indexGrid] = {
      ...dataColumnUpdated,
    };
    const updatedSummary = updatedData.listStudentSummary.find(
      (summary) => summary.studentId === student.studentId
    );
    const updatedSummaryIndex = updatedData.listStudentSummary.find(
      (summary) => summary.studentId === student.studentId
    );
    const totalPresence = getTotalPresenceByStudentId(
      updatedData.listCycleClosingAttendanceDate,
      student.studentId
    );
    const frequency = getFrequencyByPresence(
      totalPresence,
      updatedData.workDayQuantity
    );
    updatedSummary.classQuantity = totalPresence;
    updatedSummary.frequency = frequency;
    updatedData.listStudentSummary[updatedSummaryIndex] = updatedSummary;
    setData(updatedData);
  };

  const studentColumnContent = () => {
    return data.listStudentSummary.map((item) => {
      return (
        <Grid
          className="student-box-content"
          container
          item
          xs={12}
          spacing={0}
          key={item.studentId}
        >
          <Tooltip title={item.studentName}>
            <div className="form__form-group-field justify-content-center">
              <span className="student-name">{item.studentName}</span>
            </div>
          </Tooltip>
        </Grid>
      );
    });
  };

  const getColorFrequency = (minFrequency, frequency) => {
    return frequency >= minFrequency ? 'success' : 'danger';
  };

  const getColorClassQuantity = (workdays, classQuantity, minFrequency) => {
    return classQuantity >= (workdays * minFrequency) / 100
      ? 'success'
      : 'danger';
  };

  const frequencyColumnContent = (minFrequency) => {
    return data.listStudentSummary.map((item) => {
      return (
        <Grid
          className="student-box-content p-0"
          container
          item
          xs={12}
          spacing={0}
          key={item.studentId}
        >
          <Tooltip title="">
            <div className="form__form-group-field justify-content-center">
              <span
                className={`student-name ${getColorFrequency(
                  minFrequency,
                  item.frequency
                )}`}
              >
                {Number(item.frequency) !== 100
                  ? getRoundPercentageWithSymbol(Number(item.frequency))
                  : getRoundPercentageWithSymbol(item.frequency)}
              </span>
            </div>
          </Tooltip>
        </Grid>
      );
    });
  };

  const registeredClassesColumnContent = (workdays, minFrequency) => {
    return data.listStudentSummary.map((item) => {
      return (
        <Grid
          className="student-box-content p-0"
          container
          item
          xs={12}
          spacing={0}
          key={item.studentId}
        >
          <div className="form__form-group-field justify-content-center">
            <span
              className={`student-name ${getColorClassQuantity(
                workdays,
                item.classQuantity,
                minFrequency
              )}`}
            >
              {item.classQuantity}
            </span>
          </div>
        </Grid>
      );
    });
  };

  const comboboxContent = (
    classe,
    indexClasse,
    student,
    indexStudent,
    dataGrid,
    indexGrid
  ) => {
    const style = { color: '' };
    const { editable } = classe;

    if (!editable) {
      style.backgroundColor = '#F3F3F3';
    }
    let content;
    switch (classe.attendance) {
      case PRESENCE_TYPE.PRESENT:
        style.color = '#6A2B8B';
        content = <>•</>;
        break;
      case PRESENCE_TYPE.LACK:
        style.color = '#D74A56';
        content = <>{classe.attendance}</>;
        break;
      case PRESENCE_TYPE.JUSTIFIED:
        style.color = '#FFB54C';
        content = <>{classe.attendance}</>;
        break;
      default:
        style.color = '#EEE';
        content = <>-</>;
    }
    return (
      <Tooltip title={classe.attendanceJustification || ''}>
        <button
          type="button"
          className="combobox"
          style={style}
          disabled={!editable}
          onClick={() =>
            changePresence(
              classe,
              indexClasse,
              student,
              indexStudent,
              dataGrid,
              indexGrid
            )
          }
        >
          {content}
        </button>
      </Tooltip>
    );
  };
  const presenceGridColumnsContent = () =>
    data.listCycleClosingAttendanceDate.map((item, indexGrid) => (
      <Grid
        container
        item
        spacing={0}
        className="presence-grid-col"
        key={item.dateInMilli}
      >
        <Grid container item spacing={0} className="date-header">
          <Label className="form__form-group-label header-label">
            {format(new Date(item.dateInMilli), 'dd/MM', {
              locale: ptBR,
            })}
          </Label>
        </Grid>
        <Grid container item spacing={0}>
          {item.closingAttendanceStudent.map((attendance, indexStudent) => (
            <Grid
              container
              item
              xs={12}
              spacing={0}
              key={attendance.studentId}
              className="student-box-content"
            >
              {attendance.classes.map((classe, indexClasse) => (
                <Fragment key={uuid()}>
                  {comboboxContent(
                    classe,
                    indexClasse,
                    attendance,
                    indexStudent,
                    item,
                    indexGrid
                  )}
                </Fragment>
              ))}
            </Grid>
          ))}
        </Grid>
      </Grid>
    ));

  return (
    <Fragment>
      {data &&
        data.listCycleClosingAttendanceDate &&
        data.listCycleClosingAttendanceDate.length && (
          <>
            <div className="d-flex align-items-end">
              {header && (
                <div className="form__form-group card__title">
                  <span className="form__form-group-label bold-text mr-2">
                    {t('general.cycle-closing-two-points')}
                  </span>
                  <span className="form__form-group-label bold-text mr-1">
                    {header.cycleName}
                  </span>
                  <span className="form__form-group-label bold-text mr-1">
                    {t('general.of-the-discipline').toLowerCase()}
                  </span>
                  <span className="form__form-group-label bold-text">
                    {header.subjectName}
                  </span>
                </div>
              )}
              <div className="presence-grid-workday">
                <span className="mr-1">
                  {t('general.lessons-held-two-points')}
                </span>
                <span className="mr-1">{data.workDayQuantity}</span>
                <span>{t('general.classes').toLowerCase()}</span>
              </div>
            </div>
            <Grid container spacing={0} className="presence-grid">
              <Grid container spacing={0} className="student-box">
                <Grid container item xs={2} spacing={0} className="header">
                  <Label className="form__form-group-label">
                    {t('general.students')}
                  </Label>
                </Grid>
                <Grid
                  container
                  item
                  xs={2}
                  spacing={0}
                  className="student-box-container"
                >
                  {studentColumnContent()}
                </Grid>
              </Grid>
              <Grid container spacing={0} className="student-box short-width">
                <Grid container item xs={2} spacing={0} className="header">
                  <Label className="form__form-group-label">
                    {t('general.freq-symbol')}
                  </Label>
                </Grid>
                <Grid
                  container
                  item
                  xs={2}
                  spacing={0}
                  className="student-box-container"
                >
                  {frequencyColumnContent(data.minFrequency)}
                </Grid>
              </Grid>
              <Grid container spacing={0} className="student-box short-width">
                <Grid container item xs={2} spacing={0} className="header">
                  <Label className="form__form-group-label">
                    {t('general.classes')}
                  </Label>
                </Grid>
                <Grid
                  container
                  item
                  xs={2}
                  spacing={0}
                  className="student-box-container"
                >
                  {registeredClassesColumnContent(
                    data.workDayQuantity,
                    data.minFrequency
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={0} className="cycle-box">
                <Grid container item xs={2} spacing={0} className="header">
                  <Label className="form__form-group-label">
                    {t('general.registered-classes')}
                  </Label>
                </Grid>
                <Grid container spacing={0} className="presence-grid-container">
                  <Grid container spacing={0} className="presence-grid-content">
                    {presenceGridColumnsContent()}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <div className="form__form-group d-flex">
              <div className="d-flex mr-3">
                <div className="presence-combobox success">•</div>
                <span className="form__form-group-label">
                  {t('general.present')}
                </span>
              </div>
              <div className="d-flex mr-3">
                <div className="presence-combobox warning">
                  {PRESENCE_TYPE.JUSTIFIED}
                </div>
                <span className="form__form-group-label">
                  {t('general.justified')}
                </span>
              </div>
              <div className="d-flex">
                <div className="presence-combobox danger">
                  {PRESENCE_TYPE.FAULTY}
                </div>
                <span className="form__form-group-label">
                  {t('general.lack')}
                </span>
              </div>
            </div>
          </>
        )}
    </Fragment>
  );
};

PresenceGridMaintenance.propTypes = {
  t: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  attendanceWrapper: PropTypes.shape(PropTypes.shape).isRequired,
  header: PropTypes.shape({
    cycleName: PropTypes.string.isRequired,
    subjectName: PropTypes.string.isRequired,
  }),
};

PresenceGridMaintenance.defaultProps = {
  header: null,
};

export default withTranslation('common')(memo(PresenceGridMaintenance));
